import type { TFunction } from "i18next";

/** The title the backend gives a session nobody has named yet. Stored
 *  data, not copy: the backend replaces exactly this string with a title
 *  derived from the first message (messages/_send.py), so the SPA sends
 *  and keeps it in English and only translates it for display. */
export const PLACEHOLDER_SESSION_TITLE = "New session";

/** A session's title as people read it: the placeholder in the UI
 *  language, any other title as it is. Display only: nothing may write
 *  this back as the title (it would stop the auto-title). */
export function displaySessionTitle(t: TFunction, title: string | null | undefined): string {
  const raw = title ?? "";
  return raw.trim() === PLACEHOLDER_SESSION_TITLE ? t("session.default_title") : raw;
}

/** Whether a (lower-case) search matches a title as stored or as shown,
 *  so "ny" finds the placeholder in a Swedish UI and "new" still does. */
export function titleMatches(t: TFunction, title: string | null | undefined, q: string): boolean {
  const raw = title ?? "";
  return raw.toLowerCase().includes(q) || displaySessionTitle(t, raw).toLowerCase().includes(q);
}

/** The title an export starts from: the session's own title, or the
 *  report title while the session still has the placeholder (a document
 *  called "New session" says nothing about its content). */
export function exportDefaultTitle(t: TFunction, title: string | null | undefined): string {
  const raw = (title ?? "").trim();
  return raw && raw !== PLACEHOLDER_SESSION_TITLE ? raw : t("session.default_report_title");
}
